'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ProvideProps2 = require('./ProvideProps');

var _ProvideProps3 = _interopRequireDefault(_ProvideProps2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProvideIndexes = function (_ProvideProps) {
  (0, _inherits3.default)(ProvideIndexes, _ProvideProps);

  function ProvideIndexes() {
    (0, _classCallCheck3.default)(this, ProvideIndexes);
    return (0, _possibleConstructorReturn3.default)(this, _ProvideProps.apply(this, arguments));
  }

  ProvideIndexes.prototype.getProps = function getProps() {
    var parent = this.getParent();
    var index = Number(parent.props.name);

    return {
      index: index
    };
  };

  return ProvideIndexes;
}(_ProvideProps3.default);

exports.default = ProvideIndexes;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/FieldsetIndex.js
 ** module id = 1273
 ** module chunks = 0
 **/